exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rc-menu-item:hover {\n  cursor: pointer; }\n\n.rc-menu-item {\n  white-space: pre; }\n\n.rc-menu-submenu:hover {\n  cursor: pointer; }\n\n.rc-menu-button {\n  margin-right: 10px; }\n\n.contextMenuBadge {\n  font-size: 9px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./app/components/tree-context/view/tree-context.scss
 ** module id = 371
 ** module chunks = 0
 **/